var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M464.856,297.929c-14.722,39.433-44.804,82.112-87.135,94.748 c-63.961,19.098-71.602,70.655-186.163,65.873c-17.862-0.744-34.371-3.256-49.538-7.264c-8.153-2.154-15.92-4.753-23.291-7.748 C51.804,416.431,16.892,356.77,13.994,294.345c-3.825-82.102,53.46-121.236,90.69-144.15 c37.231-22.914,82.102-111.701,194.76-107.886c17.176,0.589,34.313,2.937,50.919,7.438c37.907,10.259,76.441,32.951,98.834,66.124 c1.681,2.492,3.285,5.043,4.82,7.641C483.984,174.355,484.93,244.17,464.856,297.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M464.856,297.929c-14.722,39.433-44.804,82.112-87.135,94.748 c-63.961,19.098-71.602,70.655-186.163,65.873c-17.862-0.744-34.371-3.256-49.538-7.264c-8.153-2.154-15.92-4.753-23.291-7.748 C51.804,416.431,16.892,356.77,13.994,294.345c-3.825-82.102,53.46-121.236,90.69-144.15 c37.231-22.914,82.102-111.701,194.76-107.886c17.176,0.589,34.313,2.937,50.919,7.438c37.907,10.259,76.441,32.951,98.834,66.124 c1.681,2.492,3.285,5.043,4.82,7.641C483.984,174.355,484.93,244.17,464.856,297.929z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 42,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 110.48,
    height: 310.86
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,51.451 201.259,51.451  198.683,42.905  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,61.801 201.259,61.801  198.683,53.255  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,72.15 201.259,72.15  198.683,63.604  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,82.5 201.259,82.5  198.683,73.954  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,92.849 201.259,92.849  198.683,84.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,103.199 201.259,103.199  198.683,94.653  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,113.548 201.259,113.548  198.683,105.002  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,123.898 201.259,123.898  198.683,115.352  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,134.247 201.259,134.247  198.683,125.701  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,144.597 201.259,144.597  198.683,136.051  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,154.946 201.259,154.946  198.683,146.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,165.296 201.259,165.296  198.683,156.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,175.645 201.259,175.645  198.683,167.099  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,185.995 201.259,185.995  198.683,177.449  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,196.344 201.259,196.344  198.683,187.798  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,206.694 201.259,206.694  198.683,198.148  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,217.043 201.259,217.043  198.683,208.497  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,227.393 201.259,227.393  198.683,218.847  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,237.742 201.259,237.742  198.683,229.196  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,248.092 201.259,248.092  198.683,239.546  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,258.441 201.259,258.441  198.683,249.895  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,268.791 201.259,268.791  198.683,260.245  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,279.14 201.259,279.14  198.683,270.594  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,289.49 201.259,289.49  198.683,280.944  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,299.839 201.259,299.839  198.683,291.293  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,310.189 201.259,310.189  198.683,301.643  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,320.538 201.259,320.538  198.683,311.992  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,330.888 201.259,330.888  198.683,322.342  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "91.59,341.237 201.259,341.237  198.683,332.691  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.804,
    y: 42,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 110.48,
    height: 310.86
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,51.451 320.064,51.451  317.487,42.905  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,61.801 320.064,61.801  317.487,53.255  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,72.15 320.064,72.15  317.487,63.604  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,82.5 320.064,82.5  317.487,73.954  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,92.849 320.064,92.849  317.487,84.303  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,103.199  320.064,103.199 317.487,94.653  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,113.548  320.064,113.548 317.487,105.002  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,123.898  320.064,123.898 317.487,115.352  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,134.247  320.064,134.247 317.487,125.701  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,144.597  320.064,144.597 317.487,136.051  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,154.946  320.064,154.946 317.487,146.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,165.296  320.064,165.296 317.487,156.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,175.645  320.064,175.645 317.487,167.099  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,185.995  320.064,185.995 317.487,177.449  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,196.344  320.064,196.344 317.487,187.798  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,206.694  320.064,206.694 317.487,198.148  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,217.043  320.064,217.043 317.487,208.497  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,227.393  320.064,227.393 317.487,218.847  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,237.742  320.064,237.742 317.487,229.196  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,248.092  320.064,248.092 317.487,239.546  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,258.441  320.064,258.441 317.487,249.895  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,268.791  320.064,268.791 317.487,260.245  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,279.14 320.064,279.14  317.487,270.594  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,289.49 320.064,289.49  317.487,280.944  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,299.839  320.064,299.839 317.487,291.293  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,310.189  320.064,310.189 317.487,301.643  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,320.538  320.064,320.538 317.487,311.992  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,330.888  320.064,330.888 317.487,322.342  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "210.394,341.237  320.064,341.237 317.487,332.691  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 61.667,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 92.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 48.333,
    y1: 71,
    x2: 75.667,
    y2: 71
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 48.333,
    y1: 101,
    x2: 75.667,
    y2: 101
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "27.667,67 30.333,72.333  42.333,54.333  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.667,
    y: 420.667,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.667,
    y: 451.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 314.333,
    y1: 430,
    x2: 341.667,
    y2: 430
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 314.333,
    y1: 460,
    x2: 341.667,
    y2: 460
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "293.667,426 296.333,431.333  308.333,413.333  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 52,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 82.667,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 374.667,
    y1: 61.333,
    x2: 402,
    y2: 61.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 374.667,
    y1: 91.333,
    x2: 402,
    y2: 91.333
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "354,57.333 356.667,62.667  368.667,44.667  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 470.524,
    y1: 448.858,
    x2: 485.404,
    y2: 448.858
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 25,
    y1: 448.858,
    x2: 463.591,
    y2: 448.858
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 79.511,
    cy: 351.197,
    rx: 11.647,
    ry: 30.549
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M115.699,332.357c-3.641,11.459-10.636,19.465-15.623,17.88 c-4.987-1.585-6.079-12.159-2.438-23.618c3.641-11.46,10.635-19.465,15.623-17.88 C118.248,310.324,119.339,320.898,115.699,332.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M30.239,401.457c-11.855-2.008-20.757-7.819-19.883-12.979 c0.874-5.16,11.193-7.714,23.048-5.706c11.855,2.008,20.757,7.819,19.883,12.979C52.413,400.91,42.095,403.465,30.239,401.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M126.663,373.214c-9.902,9.82-21.601,14.078-26.13,9.511 c-4.529-4.567-0.174-16.23,9.727-26.05c9.902-9.82,21.601-14.078,26.13-9.511C140.92,351.731,136.565,363.394,126.663,373.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M58.434,346.278c9.575,13.892,12.428,28.537,6.373,32.711 c-6.055,4.174-18.726-3.704-28.301-17.596c-9.575-13.892-12.428-28.537-6.372-32.71 C36.188,324.508,48.859,332.387,58.434,346.278z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 80.328,
    y1: 380.222,
    x2: 81.23,
    y2: 422.224
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 79.242,
    y1: 339.838,
    x2: 80.328,
    y2: 380.222
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 79.321,
    y1: 333.249,
    x2: 79.242,
    y2: 336.343
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M64.762,377.005 c5.838,12.262,10.585,27.154,11.503,44.074"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M44.756,346.397 c5.43,6.268,13.413,16.76,20.006,30.608"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M38.461,339.741 c0,0,1.208,1.103,3.192,3.213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M101.257,381.317 c-6.795,9.392-13.619,21.684-18.881,37.471"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M114.656,365.92 c-4.112,3.901-8.749,8.969-13.399,15.397"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M128.963,355.016 c0,0-4.154,2.129-10.203,7.229"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M100.766,347.398 c-6.452,20.305-15.113,50.31-19.155,76.354"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M104.697,335.353 c-1.148,3.424-2.484,7.49-3.931,12.045"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M108.724,323.703 c0,0-1.128,3.108-2.943,8.44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M52.691,392.937 c8.06,3.057,15.931,8.954,19.756,20.123"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M37.799,389.909 c4.339,0.255,9.655,1.042,14.891,3.028"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M28.15,390.147 c0,0,1.435-0.205,3.802-0.298"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M131.691,401.457c11.855-2.008,20.757-7.819,19.883-12.979 c-0.874-5.16-11.193-7.714-23.048-5.706c-11.855,2.008-20.757,7.819-19.883,12.979 C109.518,400.91,119.836,403.465,131.691,401.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M109.496,392.841 c-8.149,3.029-16.146,8.932-20.012,20.219"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M125.379,389.849 c-4.476,0.17-10.217,0.886-15.883,2.992"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M133.781,390.147 c0,0-0.945-0.135-2.567-0.236"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M109.326,448.751c3.478-7.277,5.508-15.678,5.508-24.044c0-5.182-0.785-10.136-2.203-14.702 H50.593c-1.418,4.566-2.203,9.52-2.203,14.702c0,8.366,2.03,16.768,5.508,24.044H109.326z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A7A7A"
    },
    d: "M49.001,416.878c-0.178,1.129-0.314,2.276-0.415,3.437h66.051 c-0.101-1.16-0.238-2.307-0.415-3.437H49.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A7A7A"
    },
    d: "M113.934,434.444c0.207-1.139,0.387-2.285,0.523-3.437H48.766 c0.136,1.152,0.316,2.297,0.523,3.437H113.934z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M56.409,424.897c0,1.476-1.197,2.673-2.673,2.673s-2.673-1.197-2.673-2.673 c0-1.476,1.197-2.673,2.673-2.673S56.409,423.421,56.409,424.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M69.774,424.897c0,1.476-1.197,2.673-2.673,2.673c-1.476,0-2.673-1.197-2.673-2.673 c0-1.476,1.197-2.673,2.673-2.673C68.577,422.224,69.774,423.421,69.774,424.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M83.139,424.897c0,1.476-1.197,2.673-2.673,2.673c-1.476,0-2.673-1.197-2.673-2.673 c0-1.476,1.197-2.673,2.673-2.673C81.942,422.224,83.139,423.421,83.139,424.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M96.505,424.897c0,1.476-1.197,2.673-2.673,2.673c-1.476,0-2.673-1.197-2.673-2.673 c0-1.476,1.197-2.673,2.673-2.673C95.308,422.224,96.505,423.421,96.505,424.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8C8C"
    },
    d: "M109.87,424.897c0,1.476-1.197,2.673-2.673,2.673c-1.477,0-2.673-1.197-2.673-2.673 c0-1.476,1.197-2.673,2.673-2.673C108.673,422.224,109.87,423.421,109.87,424.897z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.162,
    y: 84.46,
    style: {
      fill: "#263238"
    },
    width: 234.283,
    height: 331.284
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.371,
    y: 78.67,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 234.283,
    height: 331.284
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.236,
    y: 111.552,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 212.91,
    height: 60.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.236,
    y: 99.221,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 69.874,
    height: 12.331
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.272,
    y: 99.221,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 69.874,
    height: 12.331
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 131.281,
    x2: 451.145,
    y2: 131.281
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 150.188,
    x2: 451.145,
    y2: 150.188
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.236,
    y: 190.04,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 212.91,
    height: 60.009
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 209.77,
    x2: 451.145,
    y2: 209.77
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 228.677,
    x2: 451.145,
    y2: 228.677
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 116.366,
    x2: 267.599,
    y2: 116.366
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 373.751,
    y1: 116.366,
    x2: 399.635,
    y2: 116.366
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 102.332,
    x2: 267.599,
    y2: 102.332
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 382.363,
    y1: 102.332,
    x2: 408.248,
    y2: 102.332
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 135.078,
    x2: 267.599,
    y2: 135.078
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 155.661,
    x2: 267.599,
    y2: 155.661
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 321.67,
    y1: 155.661,
    x2: 347.554,
    y2: 155.661
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 317.496,
    y1: 100.149,
    x2: 369.265,
    y2: 100.149
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 317.496,
    y1: 105.451,
    x2: 369.265,
    y2: 105.451
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 312.279,
    y1: 166.848,
    x2: 324.016,
    y2: 166.848
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 326.95,
    y1: 166.848,
    x2: 338.686,
    y2: 166.848
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 341.621,
    y1: 166.848,
    x2: 353.357,
    y2: 166.848
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.236,
    y: 262.661,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 212.91,
    height: 60.009
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M242.906,278.098 c0,0,3.96-9.9,1.584-7.524c-2.376,2.376-4.356,10.692,1.584,8.712c5.94-1.98,9.9-10.692,8.316-7.128 c-1.584,3.564-0.792,6.336,3.96,3.564c4.752-2.772,5.544-2.772,5.94-1.188c0.396,1.584,1.584,1.188,5.94-0.396 c4.356-1.584,3.96,1.188,3.96,2.376c0,1.188,5.544,0.792,7.524,0c1.98-0.792,3.564-3.168,3.96-0.396 c0.396,2.772,4.356,2.772,4.356,2.772s3.168,0,4.752,0c1.584,0,5.94,0,5.94,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 282.39,
    x2: 451.145,
    y2: 282.39
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 238.236,
    y1: 301.297,
    x2: 451.145,
    y2: 301.297
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 267.475,
    x2: 267.599,
    y2: 267.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 373.751,
    y1: 267.475,
    x2: 399.635,
    y2: 267.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 286.187,
    x2: 267.599,
    y2: 286.187
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.714,
    y1: 306.77,
    x2: 267.599,
    y2: 306.77
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 321.67,
    y1: 306.77,
    x2: 347.554,
    y2: 306.77
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 312.279,
    y1: 317.957,
    x2: 324.016,
    y2: 317.957
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 326.95,
    y1: 317.957,
    x2: 338.686,
    y2: 317.957
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 341.621,
    y1: 317.957,
    x2: 353.357,
    y2: 317.957
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.326,
    y1: 196.189,
    x2: 304.21,
    y2: 196.189
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.326,
    y1: 215.995,
    x2: 280.737,
    y2: 215.995
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 337.953,
    y1: 215.995,
    x2: 375.363,
    y2: 215.995
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 396.636,
    y1: 240.935,
    x2: 434.046,
    y2: 240.935
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 388.567,
    y1: 215.995,
    x2: 425.977,
    y2: 215.995
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.232,
    y: 236.534,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.802,
    height: 8.802
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 335.752,
    y1: 240.935,
    x2: 373.163,
    y2: 240.935
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.348,
    y: 236.534,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.802,
    height: 8.802
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 274.869,
    y1: 240.935,
    x2: 312.279,
    y2: 240.935
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.464,
    y: 236.534,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.802,
    height: 8.802
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 425.654,
    y1: 334.094,
    x2: 450.184,
    y2: 334.094
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 328.29,
    y1: 334.094,
    x2: 422.493,
    y2: 334.094
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 267.596,
    y1: 334.094,
    x2: 325.445,
    y2: 334.094
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 334.094,
    x2: 265.383,
    y2: 334.094
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 396.572,
    y1: 339.784,
    x2: 450.184,
    y2: 339.784
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 294.15,
    y1: 339.784,
    x2: 394.042,
    y2: 339.784
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 339.784,
    x2: 290.988,
    y2: 339.784
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 410.481,
    y1: 345.475,
    x2: 450.184,
    y2: 345.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 325.129,
    y1: 345.475,
    x2: 408.268,
    y2: 345.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 276.447,
    y1: 345.475,
    x2: 320.703,
    y2: 345.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 345.475,
    x2: 273.602,
    y2: 345.475
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 432.293,
    y1: 351.165,
    x2: 450.184,
    y2: 351.165
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 253.054,
    y1: 351.165,
    x2: 429.132,
    y2: 351.165
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 351.165,
    x2: 250.525,
    y2: 351.165
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 436.402,
    y1: 356.855,
    x2: 450.184,
    y2: 356.855
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 392.462,
    y1: 356.855,
    x2: 433.557,
    y2: 356.855
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 325.129,
    y1: 356.855,
    x2: 390.249,
    y2: 356.855
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 262.222,
    y1: 356.855,
    x2: 322.6,
    y2: 356.855
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 356.855,
    x2: 258.745,
    y2: 356.855
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 425.338,
    y1: 362.545,
    x2: 450.184,
    y2: 362.545
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 345.677,
    y1: 362.545,
    x2: 421.861,
    y2: 362.545
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 294.15,
    y1: 362.545,
    x2: 341.567,
    y2: 362.545
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 362.545,
    x2: 290.988,
    y2: 362.545
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 388.985,
    y1: 368.235,
    x2: 450.184,
    y2: 368.235
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 267.596,
    y1: 368.235,
    x2: 384.559,
    y2: 368.235
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 239.659,
    y1: 368.235,
    x2: 264.118,
    y2: 368.235
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 241.859,
    y1: 385.442,
    x2: 268.267,
    y2: 385.442
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 372.429,
    y1: 385.442,
    x2: 398.837,
    y2: 385.442
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 274.869,
    y1: 385.442,
    x2: 363.627,
    y2: 385.442
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 406.172,
    y1: 385.442,
    x2: 449.451,
    y2: 385.442
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M245.156,207.305 c0,0,4.081,0.942,5.023-3.767c0.942-4.709-2.825-2.197-2.825,0.314s1.256,5.023,5.964,1.256c4.709-3.767,3.453-3.139,6.279-0.314 c2.825,2.825,0.314,3.453,5.965,1.256c5.651-2.197,5.964-1.256,5.651,0.628c-0.314,1.883-1.57,0.942,3.767-0.942 c5.337-1.883,7.848-3.453,7.22-0.942c-0.628,2.511-2.825,3.139,1.256,0.314c4.081-2.825,6.592-11.929,3.139-5.023 c-3.453,6.906-4.709,5.965,0.314,5.023c5.023-0.942,6.592-4.395,6.592-1.884c0,2.511-4.081,4.081,0,2.511s5.651-3.139,5.651-1.57 c0,1.57-3.767,4.395,1.57,1.883c5.337-2.511,6.906-5.337,6.906-3.139c0,2.197-0.942,1.57,0,2.197 c0.942,0.628-0.942-1.256,1.884-0.314c2.825,0.942,1.57,2.825,5.651,1.256c4.081-1.57,3.767-3.767,5.965-1.57 c2.197,2.198,0,5.337,5.964,2.511c5.965-2.825,7.534-1.256,9.418-0.942c1.884,0.314,3.453,0.314,4.709,0.314 c1.256,0,0.942-1.256,4.081,0c3.139,1.256,4.081,1.256,5.964,1.256c1.884,0,3.767,0,3.767,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M374.178,207.619 c0,0,1.57-0.628,4.395-2.197s10.046-6.906,10.359-3.453c0.314,3.453-7.848,7.848-6.906,4.081 c0.942-3.767,6.592-1.883,10.673-0.314s5.023-0.314,10.046-0.314s4.395,1.57,6.906,2.197c2.511,0.628,1.57,0,5.964-1.883 c4.395-1.883,1.256-10.987-1.57-4.709c-2.825,6.278-3.767,8.79,2.825,5.651c6.592-3.139,4.709,0.628,5.651,0.628 s-0.628,0.314,3.139-1.256c3.767-1.57-0.942,0.628,1.884,1.256c2.825,0.628,4.395-2.511,6.906-3.453 c2.511-0.942,2.825,1.883,2.825,1.883h2.511"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M243.272,147.032 c0,0,1.57-0.628,4.081-4.395c2.511-3.767-1.57-5.023-2.511-0.942c-0.942,4.081-3.139,8.79,3.767,5.337 c6.906-3.453,4.395-10.046,2.197-5.023c-2.197,5.023-1.57,10.046,5.023,6.278s7.22-5.965,8.162-4.081 c0.942,1.883-2.511,2.511,3.139,2.825c5.651,0.314,6.592-1.57,9.104-2.511c2.511-0.942,3.767,0,3.767,0s0.942,0.314,2.197,0.314 c1.256,0,2.825-0.942,3.453,0c0.628,0.942-6.278,2.197,1.884,0.942c8.162-1.256,10.046-6.592,10.673-2.511 c0.628,4.081-5.651,7.534-5.651,3.767c0-3.767,3.767-7.534,9.732-4.081c5.965,3.453,5.651,4.395,8.79,5.023 c3.139,0.628,8.162-2.825,8.162-2.825s-0.314,0.314,1.57,1.256c1.884,0.942,1.256,0.942,4.709,0 c3.453-0.942,0.628-0.314,5.337-0.942c4.709-0.628,6.906-0.314,5.023,1.256c-1.883,1.57-7.22-0.628-0.314-1.883 c6.906-1.256,7.848,0.942,7.848,1.883c0,0.942,1.884,1.256,3.453,0.628c1.57-0.628,4.709-0.942,4.709-0.942"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.434,128.511 c0,0,3.948-0.617,7.435-1.85c2.076-0.734,3.988-1.687,4.808-2.858c2.198-3.139-4.395-2.197-8.476,1.884 c-4.081,4.081,2.511,4.395,10.987,1.57c8.476-2.825,8.162-10.046,2.511-4.709c-5.651,5.337-3.453,6.592,5.337,4.709 c8.79-1.883,19.777-4.081,16.324-0.942c-3.453,3.139-4.395,1.57,1.57,0.314c5.965-1.256,9.732-4.081,8.79-1.884 c-0.942,2.198-3.453,5.023,1.256,2.825c4.709-2.197,4.081,0,4.081,0c8.476-0.942,13.185-11.615,7.22-7.848 c-5.965,3.767-5.965,8.79-0.628,8.476c5.337-0.314,10.359-5.337,7.848-2.825c-2.511,2.511-6.592,4.395,2.197,2.197 c8.79-2.197,11.615-6.906,10.987-3.767c-0.628,3.139-0.942,2.825,2.197,2.825c3.139,0,8.79-4.395,6.906-1.256 c-1.883,3.139-2.825,3.453,0,2.825c2.825-0.628,6.906-2.825,8.162-2.825c1.256,0-2.511,3.453,1.256,3.139 c3.767-0.314,11.615-5.023,11.615-5.023"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M355.029,123.488 c0,0,7.848,5.337,9.732,5.337"
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 322.48,238.785 323.414,243.141 333.06,231.628  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M215.774,428.705l7.86,7.658c0,0,17.936,6.651,18.742,7.86c0.806,1.209,0,4.635,0,4.635h-41.314l1.093-16.453L215.774,428.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M242.73,446.238 h-41.493l-0.174,2.62h41.314C242.376,448.858,242.688,447.531,242.73,446.238z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M130.873,297.206 l5.667,67c0,0-4.566,40.353-4.566,44.353s-2,17-2,17l13.667,1.667l18.233-69.019l2.667-28l22.333,50.333l15.282,51.865l13.619-3.7 l-10.568-66.499l-19.583-62.667l-1.417-7.333l-53.333,0.667V297.206z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M129.973,425.559l-4,10.919c0,0-7.457,8.666-6.852,10.278c0.605,1.612,2.015,2.015,2.015,2.015h18.541 c0,0,1.411-0.202,1.814-2.015c0.403-1.814,0.403-4.434,0.403-4.434l1.746-15.097L129.973,425.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M141.491,446.756c0.057-0.256,0.105-0.528,0.147-0.806h-22.423c-0.116,0.341-0.162,0.624-0.094,0.806 c0.604,1.612,2.015,2.015,2.015,2.015h18.541C139.677,448.771,141.088,448.57,141.491,446.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M149.873,201.289c0,0-17.5,1-22.75,4.5s-30.75,24.5-30.75,24.5l1.305,21.841l28.195-20.341l4,70.5l55.75-2.75l-1.25-39.25 l-0.75-1.25c0,0,18,18.5,24.75,18s8.25-11.75,3.25-18.75s-12.5-17-17.75-24.5s-5.25-18.5-13-23.75s-21.25-8.25-21.25-8.25 L149.873,201.289z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 184.373,
    y1: 260.289,
    x2: 183.277,
    y2: 237.724
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 186.85,
    y1: 246.708,
    x2: 187.494,
    y2: 242.844
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 184.783,
    y1: 259.107,
    x2: 186.387,
    y2: 249.485
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 161.49,
    y1: 273.531,
    x2: 164.002,
    y2: 276.273
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 134.488,
    y1: 244.048,
    x2: 159.907,
    y2: 271.802
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.618,
    y1: 262.113,
    x2: 153.462,
    y2: 271.756
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.704,
    y1: 257.3,
    x2: 141.532,
    y2: 260.07
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 134.187,226.279 125.873,231.789 133.886,231.098  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M148.136,180.899c0,0,0.904,5.872,0.904,11.519c0,5.646-0.904,11.293-0.904,11.293s11.293,17.165,13.326,18.52 c2.033,1.355,3.388-4.517,3.388-7.001c0-2.484,0.226-9.712,0.226-9.712v-8.131L148.136,180.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M165.041,206.632c0.02-0.683,0.034-1.115,0.034-1.115v-8.131l-3.831-3.729l-9.371-3.784L165.041,206.632z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M175.69,158.313c0,0,2.71,8.808,2.936,12.422s-1.807,6.324-1.807,7.453c0,1.129,3.162,5.646,3.162,7.227 c0,1.581-3.84,3.614-3.84,3.614s-1.581,8.357-5.646,11.067s-13.326-3.839-16.939-7.227c-3.614-3.388-5.195-6.55-6.324-10.163 c-1.129-3.614,0.226-11.97,2.484-18.746c2.259-6.776,7.227-9.938,12.422-10.841C167.334,152.215,175.013,155.151,175.69,158.313 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M172.302,179.656c0,1.06-0.354,1.92-0.79,1.92c-0.436,0-0.79-0.859-0.79-1.92 c0-1.06,0.354-1.92,0.79-1.92C171.949,177.737,172.302,178.596,172.302,179.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M170.044,175.704 c0,0,3.162-1.581,4.969,0.452"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M171.851,192.417 c0,0-4.743-1.581-4.969-4.969"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M149.029,180.07 c0,0,4.291,0.678,4.743-1.581c0.452-2.259-2.258-2.71,0.678-4.743c2.936-2.033,4.969-2.033,5.872-3.388 c0.903-1.355-0.363-3.539,1.218-7.152c1.581-3.614,3.483-2.678,8-2c4.517,0.678,7.495,2.603,7.495,2.603s2.775-5.881-0.162-9.269 c-2.936-3.388-12.277-6.829-22.667-3.667c-10.389,3.162-13.535,10.677-14.438,18.808c-0.904,8.131,2.258,12.648,5.195,13.551 C147.899,184.135,149.029,180.07,149.029,180.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M151.298,179.543c0,0-2.71-8.357-4.969-4.065c-2.259,4.291-1.129,7.905,1.129,9.26c2.259,1.355,3.162-1.129,3.162-1.129"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M201.224,265.078 c2.876-5.292,15.629-20.854,15.629-20.854l8.309,4.029c0,0-6.295,22.914-9.317,26.187c-3.022,3.273-6.34,4.38-9.865,1.862"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M206.162,276.12 c3.318,1.803,7.114,1.119,9.865-1.862c0.912-0.988,2.121-3.767,3.366-7.162c-9.041,1.558-13.187-4.488-14.602-7.316 c-1.976,2.739-3.504,5.066-3.872,6.168c-0.103,0.309,0.726,4.141,0.679,4.426"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M300.723,279.215c-0.191,0-0.387-0.037-0.574-0.115l-10.668-4.434c-0.766-0.317-1.128-1.195-0.81-1.96 c0.317-0.765,1.197-1.127,1.96-0.81l10.668,4.434c0.766,0.317,1.128,1.195,0.81,1.96 C301.87,278.867,301.311,279.215,300.723,279.215z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M267.411,271.446L30.253,165.017c-3.779-1.696-5.468-6.134-3.772-9.913l0,0c1.696-3.779,6.135-5.468,9.914-3.772L273.551,257.76 L267.411,271.446z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M62.442,163.02 l-26.047-11.689c-3.779-1.696-8.218-0.007-9.914,3.772c-1.696,3.779-0.007,8.217,3.772,9.913l25.402,11.486L62.442,163.02z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 273.551,257.76 297.292,274.023 295.808,277.177 267.411,271.446  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M56.136,160.19 l-19.741-8.859c-3.779-1.696-8.218-0.007-9.914,3.772c-1.696,3.779-0.007,8.217,3.772,9.913l18.917,8.49L56.136,160.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M80.123,175.789 c0,0-2,10.75-0.5,12.75s9.75,9.5,9.75,9.5s-3.25,43.75-2.5,47.75s9.25,7,12,6.25s4.75-3.75,7.25-9.25s-8.75-44-8.75-45.75 s-5.25-15.25-5.25-15.25s4.25-3,5-4s-3-0.25-3.75-0.25s-6.25-1-7.25-1.5S80.123,175.789,80.123,175.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M92.224,177.484 c0,0-3.541,0.885-3.414,1.77c0.126,0.885,0.126,6.449,0.126,6.449"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M86.786,176.599 c0,0-3.035-0.126-3.035,1.517c0,1.644,0,6.955,0,6.955"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 80.084,
    y1: 176.472,
    x2: 80.59,
    y2: 185.071
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M98.873,252.039 c2.75-0.75,4.75-3.75,7.25-9.25c0.943-2.074-0.07-8.84-1.697-16.557c-6.621,4.523-13.44,3.212-17.05,1.952 c-0.486,8.589-0.792,16.06-0.503,17.605C87.623,249.789,96.123,252.789,98.873,252.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M216.757,232.241c0,0,1.67-1.484,3.711-1.299c2.041,0.186,2.412,3.154,2.226,5.751c-0.186,2.597-2.968,3.154-3.339,1.484 c-0.371-1.67-0.742-4.267-0.742-4.267L216.757,232.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M222.322,232.056c0,0,2.412-0.742,3.525,1.67c1.113,2.412-0.186,5.566-1.484,5.751c-1.299,0.186-1.67-2.783-1.67-2.783 L222.322,232.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M225.847,233.725c0,0,1.855-0.928,2.597,1.299c0.742,2.226,1.484,5.009-0.186,5.009c-1.67,0-2.226-2.968-2.226-2.968 L225.847,233.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M228.445,235.024c0,0,2.412-0.186,2.969,1.299c0.556,1.484,1.67,4.267-0.371,4.267c-0.557,0-1.855-2.597-1.855-2.597 L228.445,235.024z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillForm);
export default __webpack_public_path__ + "static/media/fill-form.bc4fde543e5ce053c253d9c18c68c632.svg";
export { ForwardRef as ReactComponent };